type MapTarget = {
  address: string;
  latitude?: number | null;
  longitude?: number | null;
};

// Lien Google Maps : ouvre la fiche du lieu sur desktop et lance
// l'app GPS (Maps / Plans) sur mobile. On privilégie les coordonnées
// GPS quand elles existent, sinon on cherche par adresse.
export function gymMapUrl(gym: MapTarget): string {
  const query =
    gym.latitude != null && gym.longitude != null
      ? `${gym.latitude},${gym.longitude}`
      : encodeURIComponent(gym.address);
  return `https://www.google.com/maps/search/?api=1&query=${query}`;
}

// URL d'embed Google Maps sans clé API (le paramètre `output=embed` n'est pas
// documenté mais reste stable de longue date). Coordonnées GPS prioritaires,
// sinon recherche par adresse. Nécessite `frame-src https://maps.google.com`
// dans la CSP Nginx.
export function gymMapEmbedUrl(gym: MapTarget): string {
  const q =
    gym.latitude != null && gym.longitude != null
      ? `${gym.latitude},${gym.longitude}`
      : encodeURIComponent(gym.address);
  return `https://maps.google.com/maps?q=${q}&z=15&hl=fr&output=embed`;
}
